import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { Button, Input } from 'reactstrap';

import ClickableIcon from '~components/ClickableIcon';
import ErrorResponse from '~components/ErrorResponse';
import { faCog } from '~components/icon';
import Modal from '~components/Modal';

import { upsert } from '~main/actions/formDefaults';

import { FormDefault } from '~main/reducers/formDefaults';

import { selectFormDefaultsError } from '~main/selectors/formDefaults';

interface ComponentProps {
  formDefaults: FormDefault[];
  iconColor?: string;
}

const CaseManagementSettings: React.FC<ComponentProps> = ({ formDefaults, iconColor = 'black' }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [defaults, setDefaults] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const error = useAppSelector(selectFormDefaultsError);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    setDefaults((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (formDefaults?.length) {
      const defaultsToSet = Object.fromEntries(
        formDefaults
          .filter(({ feature_type }) => feature_type === 'casemanagement')
          .map(({ key, value }) => [key, value]),
      );
      setDefaults(defaultsToSet);
    }
  }, [formDefaults]);

  const handleSave = async () => {
    setIsLoading(true);

    const builtDefaults = Object.entries(defaults).map(([key, value]) => ({
      key,
      value,
      feature_tag: 'appointments',
      feature_type: 'casemanagement',
    }));

    const { payload } = await dispatch(upsert(builtDefaults));

    if (payload.success) {
      setIsLoading(false);
      setIsModalOpen(false);
      window.location.reload();
    } else {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ClickableIcon
        id="case-management-settings-icon"
        icon={faCog}
        color={iconColor}
        onClick={() => setIsModalOpen(true)}
        dataCy="case-management-settings-icon"
      />
      <Modal
        setIsOpen={setIsModalOpen}
        isOpen={isModalOpen}
        header="Edit Case Management Settings"
        headerClassName="case-management-header"
        size="lg"
        className="appointment-settings"
        data-cy="case-management-settings-modal"
        footer={
          <>
            <Button size="sm" className="ps-4 pe-4" color="success" onClick={handleSave} disabled={isLoading}>
              Save
            </Button>
            <Button size="sm" className="ps-4 pe-4" onClick={() => setIsModalOpen(false)}>
              Back
            </Button>
          </>
        }
      >
        <ErrorResponse message={error} />
        <span className="settings-header">Notes Default Field:</span>
        <Input type="textarea" className="default-notes" name="notes" value={defaults.notes} onChange={handleChange} />
      </Modal>
    </>
  );
};

export default CaseManagementSettings;
